@if (moneybarData) {
  <div class="o100w-moneybar-sidepanel" [ngClass]="'o100w-moneybar-sidepanel--' + color">
    <div class="o100w-moneybar-sidepanel-column o100w-moneybar-sidepanel-column--title">
      <p class="o100w-moneybar-sidepanel-cell">Received:</p>
      <p class="o100w-moneybar-sidepanel-cell">Future:</p>
      <p class="o100w-moneybar-sidepanel-cell">Pledged:</p>
      <p class="o100w-moneybar-sidepanel-cell">Buffer:</p>
    </div>
    <div class="o100w-moneybar-sidepanel-column o100w-moneybar-sidepanel-column--currency">
      <p class="o100w-moneybar-sidepanel-cell">€</p>
      <p class="o100w-moneybar-sidepanel-underline o100w-moneybar-sidepanel-cell">€</p>
      <p class="o100w-moneybar-sidepanel-cell">€</p>
      <p class="o100w-moneybar-sidepanel-cell">€</p>
    </div>
    <div class="o100w-moneybar-sidepanel-column o100w-moneybar-sidepanel-column--amount">
      <p class="o100w-moneybar-sidepanel-cell o100w-moneybar-sidepanel-amount-value">
        {{ moneybarData.donated | currency: 'eur' : '' }}
      </p>
      <p class="o100w-moneybar-sidepanel-underline o100w-moneybar-sidepanel-cell o100w-moneybar-sidepanel-amount-value">
        {{ moneybarData.presentValueOfFuturePayments | currency: 'eur' : '' }}
      </p>
      <p class="o100w-moneybar-sidepanel-cell o100w-moneybar-sidepanel-amount-value">
        {{ this.moneybarData.donated + this.moneybarData.presentValueOfFuturePayments | currency: 'eur' : '' }}
      </p>
      <p class="o100w-moneybar-sidepanel-cell o100w-moneybar-sidepanel-amount-value">
        {{ moneybarData.buffer | currency: 'eur' : '' }}
      </p>
    </div>
    <div class="o100w-moneybar-sidepanel-column o100w-moneybar-sidepanel-column--percentage">
      <p class="o100w-moneybar-sidepanel-cell">({{ receivedPercentage | number: '1.1-1' }}%)</p>
      <p class="o100w-moneybar-sidepanel-cell">({{ futurePercentage | number: '1.1-1' }}%)</p>
      <p class="o100w-moneybar-sidepanel-cell">({{ pledgedPercentage | number: '1.1-1' }}%)</p>
      <p class="o100w-moneybar-sidepanel-cell">({{ bufferPercentage | number: '1.1-1' }}%)</p>
    </div>
  </div>
}
